import { isTouchDevice } from '../common/util'
import tippy from 'tippy.js/esm'
import 'tippy.js/index.css'
import 'tippy.js/themes/light.css'

const SELECTORS = Selectors({
  tooltip: '[data-tippy]'
})

const $tooltips = document.querySelectorAll(SELECTORS.tooltip)

const fn = {
  init: () => {
    if (!isTouchDevice()) {
      tippy.setDefaults({
        theme: 'light',
        arrow: true,
        delay: 40
      })
    }
  }
}

export default {
  can: () => $tooltips.length,
  run: fn.init
}
